// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b43ac7e07dcdb011652c","655":"079f0f56232db600b245"}[chunkId] + ".js";
};